import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'swiper/swiper-bundle.css';
import './assets/css/main.scss'

import { createHead } from "@vueuse/head";
const head = createHead();

createApp(App).use(head).use(store).use(router).mount('#app')
